import { render, staticRenderFns } from "./AppGroup.vue?vue&type=template&id=63546219&scoped=true"
import script from "./AppGroup.vue?vue&type=script&lang=ts"
export * from "./AppGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63546219",
  null
  
)

export default component.exports